import { render, staticRenderFns } from "./fzwlqx03GameVue.vue?vue&type=template&id=0e319d30&scoped=true"
import script from "./fzwlqx03GameVue.vue?vue&type=script&lang=js"
export * from "./fzwlqx03GameVue.vue?vue&type=script&lang=js"
import style0 from "./fzwlqx03GameVue.vue?vue&type=style&index=0&id=0e319d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e319d30",
  null
  
)

export default component.exports